
export interface FnMenuItemState {
  id: string;
  menuItemArray: FnMenuItemState[];
  isEnableOnUI: boolean;
  labelIDArray: string[];
  showBreadcrum: boolean;
  isActive: boolean;
  textColor: string;
  parentID: string;
  isWalkthruConfigured: boolean;
  menuItemIDArray: string[];
  showDropIcon: boolean;
  hrefClass: string;
  name: string;
  recalAccess: boolean;
  isCustomMenu: boolean;
  applicablePK: number;
  isDisabled: boolean;
  url?: string;
  hideLabel: boolean;
  smallIcon?: string;
  menuSmallIcon?: string;
  menuType?: string;
  helpTextLBL?: string;
  customIcon?: string;
  customClass?: string;
  bigIcon?: string;
  menuBigIcon?: string;
  menuIdentifierText?: string;
}

export const DEFAULT_MENU_STATE = {
  id: '',
  menuItemArray: Array,
  isEnableOnUI: false,
  labelIDArray: Array,
  showBreadcrum: false,
  isActive: false,
  textColor: '',
  parentID: '',
  isWalkthruConfigured: false,
  menuItemIDArray: Array,
  showDropIcon: false,
  hrefClass: '',
  name: '',
  recalAccess: false,
  isCustomMenu: false,
  applicablePK: 0,
  isDisabled: false,
  hideLabel: false
};

export interface FnMenuState {
  activeMenuId: string;
  menuData: FnMenuItemState;
  menuItemDetailMap: object;
  menuItemMap: object;
  error: string;
  isMenuLoaded: boolean;
}
